
export default {
  list: []
}



// WEBPACK FOOTER //
// ./src/features/admin/funcionalidades/store/state.js